import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { reorderArray } from "ionic-angular";
import { Utilities } from "./../../providers/utilities";

@Component({
  selector: "app-widgets-right",
  templateUrl: "widgets-right.html",
})
export class WidgetsRightComponent implements OnChanges {

  @Input() public widgets: any[];
  @Input() public defaultLanguage: string;
  @Input() public language: string;
  @Output() public languageChange = new EventEmitter();
  @Output() public emitWidget = new EventEmitter();
  @Output() public emitWidgets = new EventEmitter();

  public isReorder = false;
  public isForm = false;
  public currentWidget = null;
  public widgetList = [
    { id: "product_list", name: "Product List" },
    { id: "ticket_list", name: "Ticket List" },
    { id: "service_list", name: "Service List" },
    { id: "event_list", name: "Event List" },
    { id: "coupon_list", name: "Coupon List" },
    { id: "stand_list", name: "Stand List" },
    { id: "staff_list", name: "Staff List" },
    { id: "news_list", name: "News List" },
    { id: "networking_suggestions", name: "Networking Suggestions" },
    { id: "rich_text", name: "Rich text" },
    { id: "slide_banner", name: "Banner slide" },
    { id: "product_sale", name: "Product sale" },
    { id: "ticket_sale", name: "Ticket sale" },
    { id: "service_sale", name: "Service sale" },
    { id: "sponsor_list", name: "Sponsor List" },
  ].sort((a, b) => a.name > b.name ? 1 : -1);

  constructor(
    private utilities: Utilities,
  ) { }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.widgets) {
      this.widgets = changes.widgets.currentValue;
    }
  }

  public selected(event) {
    this.languageChange.emit(event);
  }

  public getWidget(type) {
    const result = this.widgetList.filter((item) => item.id === type);
    return result[0];
  }

  public addOrUpdate(current = null) {
    const load = this.utilities.setLoading();

    return Promise.resolve()
      .then(() => {
        if (current) {
          this.currentWidget = current;
        } else {
          this.currentWidget = null;
        }
        return true;
      })
      .then(() => this.isForm = true)
      .then(() => load.dismiss());
  }

  public createOrUpdateWidget(widget) {
    const load = this.utilities.setLoading();
    return Promise.resolve()
      .then(() => this.emitWidget.emit(widget))
      .then(() => this.isForm = false)
      .then(() => load.dismiss());
  }

  public removeWidget(id: string) {
    const load = this.utilities.setLoading();
    this.emitWidgets.emit(this.widgets.filter((w) => w.id !== id));
    load.dismiss();
  }

  public reorderItems(indexes) {
    const load = this.utilities.setLoading();

    return Promise.resolve()
      .then(() => reorderArray(this.widgets, indexes))
      .then((newWidgets) => newWidgets.map((item, key) => ({ ...item, order: key })))
      .then((newWidgets) => this.emitWidgets.emit(newWidgets))
      .then(() => load.dismiss());
  }

}



// WEBPACK FOOTER //
// ./src/components/widgets-right/widgets-right.ts